"use client"

import CookieConsent from "react-cookie-consent"
import { useT } from "i18n/client"
import LocalizedClientLink from "@modules/common/components/localized-client-link"

interface CookieBannerProps {
  locale: string
}

export default function CookieBanner({ locale }: CookieBannerProps) {
  const { t } = useT("main")

  return (
    <CookieConsent
      location="bottom"
      buttonText={t("acceptAll")}
      declineButtonText={t("decline")}
      enableDeclineButton
      cookieName="cookieConsent"
      style={{ background: "#1f2937", color: "white", padding: "16px" }}
      buttonStyle={{ 
        background: "white", 
        color: "#1f2937", 
        padding: "8px 16px", 
        borderRadius: "9999px", 
        marginRight: "8px",
        border: "none",
        cursor: "pointer"
      }}
      declineButtonStyle={{ 
        background: "white", 
        color: "#1f2937", 
        padding: "8px 16px", 
        borderRadius: "9999px",
        border: "none",
        cursor: "pointer"
      }}
    >
      {t("cookieIntro")}{" "}
      <LocalizedClientLink href="/cookies" className="underline">
        {t("learnMore")}
      </LocalizedClientLink>
    </CookieConsent>
  )
}